"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAdditionalSeats = void 0;

var _requestNotificationsApi = require("ui-addon-upgrades/_core/common/api/requestNotificationsApi");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var requestAdditionalSeats = (0, _wrapWithErrorMonitoring.default)('requestAdditionalSeats', function (_ref) {
  var merchandiseId = _ref.merchandiseId,
      productName = _ref.productName;
  return (0, _requestNotificationsApi.sendRequestAdditionalSeatsNotification)(productName).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request additional seats succeeded',
      merchandiseId: merchandiseId
    });
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request additional seats failed',
      merchandiseId: merchandiseId
    });

    if (window.Raven) {
      window.Raven.captureMessage('Request additional seats notification failed', {
        extra: {
          error: e
        }
      });
    }

    throw e;
  });
});
exports.requestAdditionalSeats = requestAdditionalSeats;